import React from 'react';
import { FacetChoice } from '../../search/FacetChoice';
import { CSSTransition, TransitionGroup } from 'react-transition-group'; // ES6
import { useQueryParams, StringParam, withDefault } from 'use-query-params';
import { ArrayOfObjectsParam } from '../../hooks/utils';
import { useAdvancedSearch } from '../../hooks/useAdvancedSearch';

export function FeatureFilters(props) {
    const facetRemoved = useAdvancedSearch((state) => state.facetRemoved);
    const [query, setQuery] = useQueryParams({
        searchText: StringParam,
        filters: withDefault(ArrayOfObjectsParam, []),
    });
    let { searchText: search, filters } = query;

    function handleFacetClick(command) {
        if (command.action === 'remove') {
            const newFilters = filters.filter(
                (filter) => !(filter.id === command.value)
            );
            console.log('removing facet', command);
            facetRemoved(command.value);
            setQuery(
                {
                    searchText: search,
                    filters: newFilters,
                },
                'push'
            );
        }
    }

    const removeIconClass = 'sui-advTermRem u-icon__cancel-circle icon';

    const entries =
        filters?.map((entry) => {
            return (
                <CSSTransition key={entry.id} timeout={200} classNames="item">
                    {/*<Badge*/}
                    {/*    key={entry.id}*/}
                    {/*    pill*/}
                    {/*    variant={'secondary'}*/}
                    {/*    className={'m-2 p-2 pr-3'}*/}
                    {/*>*/}
                    <FacetChoice
                        mode={'remove'}
                        operator={'AND'}
                        key={`Remove ${entry.id}`}
                        className={removeIconClass}
                        value={entry.id}
                        labelText={entry.label}
                        label={entry.label}
                        facetType={entry.field}
                        onFacetClick={(msg) => {
                            handleFacetClick({ ...msg, action: 'remove' });
                        }}
                    />
                    {/*</Badge>*/}
                </CSSTransition>
            );
        }) || [];

    if (entries.length) {
        entries.unshift(
            <CSSTransition key="label" timeout={200} classNames="item">
                <span>Applied Filters: </span>
            </CSSTransition>
        );
    }

    return (
        <TransitionGroup className={'sui-facetList-horiz'}>
            {entries}
        </TransitionGroup>
    );
}
